<div class="string-list-add-edit-container">
	<ng-container *ngIf="data?.length === 0; else hasDataDisplay">
		<button mat-stroked-button color="primary" (click)="add()" [disabled]="disabled">EDIT VALUES</button>
	</ng-container>
	<ng-template #hasDataDisplay>
		<div class="list-header">
			<span class="header-title">
				Values
			</span>
			<span class="push--right">
				<ng-container>
					<button mat-icon-button aria-label="add" (click)="add()" matTooltip="Add New Value" [matTooltipShowDelay]="1500">
						<mat-icon color="primary">add</mat-icon>
					</button>
				</ng-container>
			</span>
		</div>
		<div cdkDropList [cdkDropListData]="data" class="values-list" (cdkDropListDropped)="drop($event)">
			<div class="list-box" *ngFor="let item of data" cdkDrag cdkDragLockAxis="y">
				<input #stringInput [(ngModel)]="item.StringValue" (ngModelChange)="onInputChange($event)" placeholder="" maxlength="50" />
				<span class="push--right value-actions">
					<ng-container>
						<button mat-icon-button aria-label="delete" (click)="remove(item)" matTooltip="Delete" [matTooltipShowDelay]="1500">
							<mat-icon color="warn">delete</mat-icon>
						</button>
						<button mat-icon-button aria-label="drag and drop" matTooltip="Drag and Drop" [matTooltipShowDelay]="1500">
							<mat-icon cdkDragHandle style="cursor: move">swap_vert</mat-icon>
						</button>
					</ng-container>
				</span>
			</div>
		</div>
	</ng-template>
</div>
